export const teamWorkflow = {
  junior: {
    processes: [
      { name: 'Daily Standup', description: 'Share progress on mobile features and platform-specific challenges', time: '9:00 AM daily' },
      { name: 'Mobile Code Review', description: 'Review code with focus on platform best practices', requirement: 'Minimum 1 approval from mobile team member' },
      { name: 'Device Testing', description: 'Test on physical devices before submission', coverage: 'Test on minimum 3 devices per platform' }
    ],
    responsibilities: [
      { area: 'Feature Development', tasks: ['Implement mobile UI/UX', 'Integrate with APIs', 'Handle platform-specific requirements', 'Test on devices'] },
      { area: 'Bug Resolution', tasks: ['Reproduce on physical devices', 'Debug using platform tools', 'Fix platform-specific issues', 'Verify across OS versions'] },
      { area: 'App Store Compliance', tasks: ['Follow platform guidelines', 'Prepare app store assets', 'Test submission builds'] }
    ],
    ceremonies: [
      { name: 'Sprint Planning', frequency: 'Bi-weekly', duration: '2 hours', role: 'Plan mobile features' },
      { name: 'Sprint Review', frequency: 'Bi-weekly', duration: '1 hour', role: 'Demo mobile features' },
      { name: 'Device Testing Session', frequency: 'Weekly', duration: '2 hours', role: 'Test on physical devices' }
    ]
  },
  mid: {
    processes: [
      { name: 'Architecture Review', description: 'Review mobile architecture and design patterns', frequency: 'Weekly' },
      { name: 'Performance Monitoring', description: 'Monitor app performance and optimize', responsibility: 'Own mobile performance metrics' },
      { name: 'Release Management', description: 'Manage app store releases and rollouts', commitment: 'Lead release process' }
    ],
    responsibilities: [
      { area: 'Platform Architecture', tasks: ['Design scalable mobile architecture', 'Plan cross-platform strategies', 'Lead technical discussions', 'Mentor junior developers'] },
      { area: 'Release Management', tasks: ['Coordinate app store releases', 'Manage beta testing', 'Monitor rollout metrics', 'Handle release issues'] },
      { area: 'Performance Optimization', tasks: ['Profile app performance', 'Optimize for battery and memory', 'Improve app startup time', 'Reduce app size'] }
    ],
    ceremonies: [
      { name: 'Architecture Review', frequency: 'Weekly', duration: '1 hour', role: 'Lead mobile architecture discussions' },
      { name: 'Release Planning', frequency: 'Monthly', duration: '2 hours', role: 'Plan app store releases' },
      { name: 'Performance Review', frequency: 'Bi-weekly', duration: '1 hour', role: 'Analyze mobile performance metrics' }
    ]
  },
  senior: {
    processes: [
      { name: 'Mobile Strategy Planning', description: 'Define mobile platform strategy and roadmap', scope: 'Company-wide mobile strategy' },
      { name: 'Technical Leadership', description: 'Lead mobile technology decisions', responsibility: 'Mobile platform ownership' },
      { name: 'Cross-platform Coordination', description: 'Coordinate mobile strategy across platforms', impact: 'Platform consistency and efficiency' }
    ],
    responsibilities: [
      { area: 'Strategic Planning', tasks: ['Define mobile technology roadmap', 'Evaluate new mobile technologies', 'Plan platform migrations', 'Drive mobile innovation'] },
      { area: 'Team Leadership', tasks: ['Lead mobile engineering teams', 'Mentor senior developers', 'Drive mobile culture', 'Cross-team collaboration'] },
      { area: 'Platform Management', tasks: ['Manage app store relationships', 'Ensure platform compliance', 'Lead security initiatives', 'Oversee mobile infrastructure'] }
    ],
    ceremonies: [
      { name: 'Mobile Leadership', frequency: 'Weekly', duration: '2 hours', role: 'Mobile platform strategy lead' },
      { name: 'Platform Review', frequency: 'Monthly', duration: '3 hours', role: 'Mobile platform architect' },
      { name: 'Technology Evaluation', frequency: 'Quarterly', duration: '4 hours', role: 'Mobile technology evaluation lead' }
    ]
  }
};
